import { eventNames, useCoreEvents } from '@carvana/core-events';
import { useCallback, useEffect } from 'react';
import { useCloseAccountModal } from './useAccountModal';

type OwnArgs = {
  isAccountModalOpen: boolean;
  setAccountModalOpen: (_: boolean) => void;
};

export default function useToggleAccountModal({
  isAccountModalOpen,
  setAccountModalOpen
}: OwnArgs) {
  const closeAccountModal = useCloseAccountModal();

  useCoreEvents(
    eventNames.accountModal.opened,
    useCallback(() => {
      setAccountModalOpen(true);
    }, [setAccountModalOpen])
  );

  useCoreEvents(
    eventNames.accountModal.closed,
    useCallback(() => {
      setAccountModalOpen(false);
    }, [setAccountModalOpen])
  );

  useEffect(() => {
    if (isAccountModalOpen) return;

    closeAccountModal();
  }, [closeAccountModal, isAccountModalOpen]);
}
